import React from "react";
import topImg from "../assets/img/church.jpg";
import church1 from "../assets/img/church/church1.jpg";
import church2 from "../assets/img/church/church2.jpg";
import church3 from "../assets/img/church/church3.jpg";
import church4 from "../assets/img/church/church4.jpg";
//import slide2 from "../assets/img/slide2.jpg";
import { Link } from "react-router";

export default function SubStations() {
  const substations = [
    {
      img: topImg,
      churchName: "St. Joseph's Church",
      place: "Anupanadi",
      patron: "St. Joseph, Worker & Protector",
      badge: "Substation Chapel"
    },
    {
      img: topImg,
      churchName: "St. Antony's Church",
      place: "Palayakuyavar Palayam",
      patron: "St. Antony of Padua",
      badge: "Substation Chapel"
    },
    {
      img: topImg,
      churchName: "St. Antony's Church",
      place: "Santhapettai",
      patron: "St. Antony of Padua",
      badge: "Substation Chapel"
    },
    {
      img: topImg,
      churchName: "St. Xavier's Church",
      place: "Savariyar Chavadi",
      patron: "St. Francis Xavier",
      badge: "Substation Chapel"
    },
    {
      img: topImg,
      churchName: "St. Antony's Church",
      place: "Soosaiyapparpuram",
      patron: "St. Antony of Padua",
      badge: "Substation Chapel"
    },
    {
      img: topImg,
      churchName: "St. Sebastian's Church",
      place: "Sebastiyarpuram",
      patron: "St. Sebastian, Martyr",
      badge: "Substation Chapel"
    },
    {
      img: topImg,
      churchName: "Our Lady of Velankanni Church",
      place: "Kamarajapuram",
      patron: "Our Lady of Good Health",
      badge: "Marian Chapel"
    },
    {
      img: topImg,
      churchName: "Our Lady of Velankanni Church",
      place: "Pokkuvarathu Nagar",
      patron: "Our Lady of Good Health",
      badge: "Marian Chapel"
    },
    {
      img: topImg,
      churchName: "St. Fathima Church",
      place: "Keeraithurai",
      patron: "Our Lady of Fatima",
      badge: "Marian Chapel"
    }
  ];

  return (
    <section id="substations" className="substations-section py-5">
      <div className="container py-4">
        {/* Section Heading */}
        <div className="section-heading-wrapper text-center mb-5">
          <div className="eyebrow-badge">
            <i className="fas fa-church"></i>
            <span>Parish Outreach & Missions</span>
          </div>
          <h2 style={{ fontFamily: "'Playfair Display', Georgia, serif", color: "var(--cathedral-navy)" }}>
            Cathedral Parish Substations
          </h2>
          <div className="cross-ornament">
            <i className="fas fa-cross"></i>
          </div>
          <p style={{ maxWidth: "760px", margin: "0 auto", color: "var(--cathedral-text-secondary)" }}>
            There are 14 substations under St. Mary’s Cathedral across Madurai. Each substation maintains its own chapel and celebrates an annual patronal feast, fostering intimate prayer, community bonding, and active lay participation.
          </p>
        </div>

        {/* Substations Grid */}
        <div className="row g-4">
          {substations.map((sub, i) => (
            <div key={i} className="col-12 col-md-6 col-lg-4">
              <div className="substation-card">
                <div className="substation-thumb">
                  <img src={sub.img} alt={`${sub.churchName}, ${sub.place}`} />
                </div>
                <div className="d-flex flex-column flex-grow-1 justify-content-between">
                  <div>
                    <span
                      className="badge mb-2"
                      style={{
                        background: "#f5eedb",
                        color: "#967226",
                        border: "1px solid #ebdcb7",
                        fontSize: "0.75rem",
                        letterSpacing: "0.5px"
                      }}
                    >
                      {sub.badge}
                    </span>
                    <h3 className="substation-name">{sub.churchName}</h3>
                    <div className="substation-location">
                      <i className="fas fa-map-marker-alt"></i>
                      <span>{sub.place}, Madurai</span>
                    </div>
                    <p style={{ fontSize: "0.84rem", color: "#6a7b8e", marginBottom: "16px" }}>
                      <i className="fas fa-cross text-secondary me-1"></i> Patron: {sub.patron}
                    </p>
                  </div>

                  <div className="pt-2 border-top d-flex justify-content-between align-items-center" style={{ borderColor: "#f0ece3" }}>
                    <span style={{ fontSize: "0.78rem", color: "#8a99a8" }}>
                      <i className="fas fa-calendar-check me-1 text-secondary"></i> Annual Feast Chapel
                    </span>
                    <Link
                      to="/contact"
                      className="btn btn-sm"
                      style={{
                        background: "#f7f5ed",
                        color: "var(--cathedral-navy)",
                        border: "1px solid #dfd7c3",
                        borderRadius: "20px",
                        fontSize: "0.8rem",
                        padding: "5px 14px",
                        fontWeight: 600
                      }}
                    >
                      <i className="fas fa-directions me-1"></i> Inquire
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Note on 14 Substations */}
        <div className="mt-5 text-center p-4 rounded-4" style={{ background: "#f9f7f2", border: "1px solid #eae3d4" }}>
          <p className="mb-0 text-muted" style={{ fontSize: "0.92rem" }}>
            <i className="fas fa-info-circle text-secondary me-2"></i>
            Additional mission stations and prayer cells in neighboring communities are served regularly through pastoral visits and Anbiyam (BCC) family gatherings.
          </p>
        </div>
      </div>
    </section>
  );
}
